var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Checkout',{class:_vm.formVisibilityformHidden}),(_vm.showSecurity)?_c('Security'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }